







































import { Component, Prop, Vue } from "vue-property-decorator";
import { mixinz } from "@/scripts/global/mixinz";
import * as blockui from '../../../helpers/block-ui';
import * as api from '@/scripts/services/api';
import * as dateFormat from '../../../helpers/dateFormat';
import { CFMCoreEntityComboSource, CFMCoreEntityResultMessage, CFMModelSparePartUsingHistorySP, CFMDTOSparePartUsingHistory } from '@/scripts/services/ClientApiAuto';
import CFMMultiselect from '@/components/partials/CFMMultiselect.vue';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { Filter, Resize, Sort } from '@syncfusion/ej2-vue-grids';
import * as swal from '@/helpers/swal'

Vue.use(DropDownListPlugin);

// Pasif (Iskarta) tek yonlu bir durum: bu duruma gelen satir bir daha degistirilemez.
// Kural hem satir bazli dropdown'da hem toplu islemde gecerli, bu yuzden tek yerde.
const PASSIVE_STATUS_ID = 3;

@Component({
    components: {
        'cfm-multiselect': CFMMultiselect
    },
    mixins: [mixinz],
    provide() {
        return {
            grid: [Sort, Filter, Resize]
        };
    },
})

export default class SparePartUsingHistoryStep extends Vue {
    @Prop() capacityEquipmentId!: number;

    sparePartUsingHistoryList: CFMModelSparePartUsingHistorySP[] = [];
    sparePartUsingStatusList: CFMCoreEntityComboSource[] = [];

    isReady: boolean = false;

    gridProps: any = {
        ref: 'grid',
        allowPaging: false,
        allowFiltering: true,
        allowSorting: true,
        allowGrouping: false,
        allowResizing: true,
        allowExcelExport: false,
        allowPdfExport: false,
        allowCsvExport: false,
    };

    sortOptions: any = { columns: [{ field: 'CreatedDate', direction: 'Descending' }] };

    filterSettings: any = { type: 'Excel' };

    // checkboxOnly: satir govdesinde durum dropdown'i var; satira tiklamak secim
    // yapsaydi dropdown'a her dokunus satiri da secerdi.
    selectionSettings: any = { type: 'Multiple', checkboxOnly: true };

    selectedRows: CFMModelSparePartUsingHistorySP[] = [];

    bulkStatusId: number | null = null;

    get canApplyBulkStatus(): boolean {
        return this.selectedRows.length > 0 && !!this.bulkStatusId;
    }

    async mounted() {
        const self = this;
        //@ts-ignore
        self.$parent.blockPage();

        const promises = [
            self.getSparePartUsingStatuses(),
            self.getSparePartUsingHistories(self.capacityEquipmentId)
        ];

        await Promise.all(promises);
        self.isReady = true;
        //@ts-ignore
        self.$parent.unBlockPage();
    }

    async getSparePartUsingStatuses() {
        const self = this;
        const response = await self.$globalApiClient.sparePartUsingHistory.getSparePartUsingStatusList();
        self.sparePartUsingStatusList = response.data;
    }

    async getSparePartUsingHistories(deviceId: number) {
        const self = this;
        const response = await self.$globalApiClient.sparePartUsingHistory.getSparePartUsingHistoryList({deviceId: deviceId});
        // Yerel dizi dataSource olarak verildiginde DataManager tarihleri revive etmiyor;
        // string kalirsa ne kolon formati ne de tarih filtresi calisir.
        self.sparePartUsingHistoryList = response.data.map(x => ({
            ...x,
            CreatedDate: x.CreatedDate ? new Date(<any>x.CreatedDate) : null
        }));
    }

    onBulkStatusChange(args: any) {
        this.bulkStatusId = args.value;
    }

    refreshSelection() {
        const grid: any = this.$refs.grid;
        this.selectedRows = grid ? grid.getSelectedRecords() : [];
    }

    async applyBulkStatus() {
        const self = this;

        if (!self.canApplyBulkStatus) return;

        const targetStatusId = <number>self.bulkStatusId;
        const targetStatus = self.sparePartUsingStatusList.find(x => x.Value === targetStatusId);

        // Pasif satirlar atlanir: o duruma gelen satir bir daha degistirilemez.
        // Zaten hedef durumda olanlar da atlanir; bu bir alan kurali degil, gereksiz
        // denetim satiri yazmamak ve "N kayit guncellendi" sayisini durust tutmak icin.
        const applicable = self.selectedRows.filter(x =>
            x.SparePartUsingStatusId !== PASSIVE_STATUS_ID &&
            x.SparePartUsingStatusId !== targetStatusId);

        if (applicable.length === 0) {
            toastr.warning(self.translate('bulk_status_update_nothing_to_do'));
            return;
        }

        let confirmMessage = self.translate('bulk_status_update_confirm')
            .formatString(applicable.length, targetStatus ? targetStatus.Text : '');
        if (targetStatusId === PASSIVE_STATUS_ID)
            confirmMessage += ' ' + self.translate('bulk_status_update_irreversible');

        const answer = await swal.check(self, self.translate('bulk_status_update'), confirmMessage, 'warning');
        if (!answer.value) return;

        //@ts-ignore
        self.$parent.blockPage();

        // Satirlar birbirinden bagimsiz oldugu icin sunucu tek tek isleyip her satir
        // icin ayri bir ResultMessage donuyor; kismi basari anlamli.
        const payload: CFMDTOSparePartUsingHistory[] = applicable.map(row => ({
            Id: 0,
            OrderSparePartId: row.OrderSparePartId,
            SparePartUsingStatusId: targetStatusId,
            UniqueCode: row.UniqueCode
        }));

        let succeeded = 0;
        let firstError = '';
        try {
            const response = await api.changeSparePartUsingStatusList(payload);
            const results: CFMCoreEntityResultMessage[] = response.body || [];
            succeeded = results.filter(x => x.IsSuccess).length;
            const failed = results.find(x => !x.IsSuccess);
            if (failed) firstError = failed.Message || self.translate('undefined_error');
        }
        catch (error) {
            console.error("Error sending form data to API:", error);
            firstError = self.translate('undefined_error');
        }

        await self.getSparePartUsingHistories(self.capacityEquipmentId);
        self.clearSelection();

        //@ts-ignore
        self.$parent.unBlockPage();

        if (succeeded > 0)
            toastr.success(self.translate('n_of_n_saved').formatString(succeeded, applicable.length));
        if (firstError)
            toastr.error(firstError);
    }

    clearSelection() {
        const grid: any = this.$refs.grid;
        if (grid) grid.clearSelection();
        this.selectedRows = [];
    }

    gridDataBound(args: any) {
        if (!args || !args.data) return;

        if (args.data.SparePartUsingStatusId === 1) {
            args.row.classList.add("b-ground-gy");
        }
        else if (args.data.SparePartUsingStatusId === 2) {
            args.row.classList.add("b-ground-c");
        }
        else {
            args.row.classList.add("b-ground-dg");
        }
        // const self = this;
        // for (let index = 0; index < self.sparePartUsingHistoryList.length; index++) {
        //     if (self.sparePartUsingHistoryList[index].SparePartUsingStatusId === 1) {
        //         //@ts-ignore
        //         self.$refs.grid.getDataRows()[index].classList.add("b-ground-gy");
        //     }
        //     else if (self.sparePartUsingHistoryList[index].SparePartUsingStatusId === 2) {
        //         //@ts-ignore
        //         self.$refs.grid.getDataRows()[index].classList.add("b-ground-c");
        //     }
        //     else {
        //         //@ts-ignore
        //         self.$refs.grid.getDataRows()[index].classList.add("b-ground-dg");
        //     }
        // }
    }

    statusTemplate(aaa: any, bbb: any) {
        return {
            template: Vue.component("statusTemplate", {
                template:
                      `<ejs-dropdownlist ref='dropdownlist' :value="populateModel" :readonly="setReadonly" @change="onChangeSparePartUsingStatusType" :fields="{ text: 'Text', value: 'Value'}" :dataSource='populateOptions'></ejs-dropdownlist>`,
                computed: {
                    populateModel() {
                        const self = <any>this;
                        return self.data.SparePartUsingStatusId;
                    },
                    populateOptions() {
                        const self = <any>this;
                        return self.$parent.$parent.sparePartUsingStatusList;
                    },
                    setReadonly() {
                        const self = <any>this;
                        return self.data.SparePartUsingStatusId === PASSIVE_STATUS_ID;
                    }
                },
                mounted() {

                },
                methods: {
                    async onChangeSparePartUsingStatusType(data: any) {
                        const self = <any>this;

                        if (data === undefined || data.value === undefined || data.previousItemData === undefined || data.previousItemData.Value === undefined) {
                            toastr.error(self.$parent.$parent.translate('undefined_error'));
                            return;
                        }

                        if(data.previousItemData.Value === PASSIVE_STATUS_ID) {
                            toastr.error(self.$parent.$parent.translate('spare_part_using_history_change_not_allowed').formatString(data.previousItemData.Text));
                            return;
                        }
                        
                        if(data.value === PASSIVE_STATUS_ID) {                          
                            const warningAnswer = await swal.check(this, this.translate('spare_part_using_passive_warning_title'), this.translate('spare_part_using_passive_warning_message'), 'warning');
                            if (warningAnswer.value) {
                                let formData:CFMDTOSparePartUsingHistory = {
                                    Id: 0,
                                    OrderSparePartId: (<CFMModelSparePartUsingHistorySP>self.data).OrderSparePartId,
                                    SparePartUsingStatusId: data.value,
                                    UniqueCode: (<CFMModelSparePartUsingHistorySP>self.data).UniqueCode
                                };

                                await this.changeSparePartUsingStatus(formData);
                                // try {
                                //     self.$parent.$parent.$parent.blockPage();

                                //     const response = await self.$globalApiClient.sparePartUsingHistory.changeStatusByOrderSparePartId(formData);
                                //     if (response.data.IsSuccess) {
                                //         toastr.success(self.translate("save_successfully"));
                                //     } 
                                //     else {
                                //         const errorMessage = response.data.Message || "Error";
                                //         toastr.error(errorMessage);
                                //     }
                                
                                //     self.$parent.$parent.$parent.unBlockPage();
                                // } 
                                // catch (error) {
                                //     console.error("Error sending form data to API:", error);
                                //     self.$parent.$parent.$parent.unBlockPage();
                                // }
                            }
                        }
                        else {
                            let formData:CFMDTOSparePartUsingHistory = {
                                Id: 0,
                                OrderSparePartId: (<CFMModelSparePartUsingHistorySP>self.data).OrderSparePartId,
                                SparePartUsingStatusId: data.value,
                                UniqueCode: (<CFMModelSparePartUsingHistorySP>self.data).UniqueCode
                            };

                            await this.changeSparePartUsingStatus(formData);
                            // try {
                            //     self.$parent.$parent.$parent.blockPage();

                            //     const response = await self.$globalApiClient.sparePartUsingHistory.changeStatusByOrderSparePartId(formData);
                            //     if (response.data.IsSuccess) {
                            //         toastr.success(self.translate("save_successfully"));
                            //     } 
                            //     else {
                            //         const errorMessage = response.data.Message || "Error";
                            //         toastr.error(errorMessage);
                            //     }
                            
                            //     self.$parent.$parent.$parent.unBlockPage();
                            // } 
                            // catch (error) {
                            //     console.error("Error sending form data to API:", error);
                            //     self.$parent.$parent.$parent.unBlockPage();
                            // }
                        }

                        await self.$parent.$parent.getSparePartUsingHistories(self.$parent.$parent.capacityEquipmentId);
                    },

                    async changeSparePartUsingStatus(formData: CFMDTOSparePartUsingHistory) {
                        const self = <any>this;
                        try {
                            self.$parent.$parent.$parent.blockPage();

                            const response = await self.$globalApiClient.sparePartUsingHistory.changeStatusByOrderSparePartId(formData);
                            if (response.data.IsSuccess) {
                                toastr.success(self.translate("save_successfully"));
                            } 
                            else {
                                const errorMessage = response.data.Message || "Error";
                                toastr.error(errorMessage);
                            }
                        
                            self.$parent.$parent.$parent.unBlockPage();
                        } 
                        catch (error) {
                            console.error("Error sending form data to API:", error);
                            self.$parent.$parent.$parent.unBlockPage();
                        }
                    }
                }
            })
        };
    }
}
